import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IClientPortalCaseTypesService } from "services/ClientPortalCaseTypesService";
import { IntSelectModel } from "services/api/cplapi/CPLAPI";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { container } from "setup/dependency/inversify.config";
import { RootState } from "setup/redux/RootReducer";

const initialState = {
  CaseTypeSelectModels: new Array<IntSelectModel>(),
  Loading: false,
  LastUpdateTime: new Date(),
};

export const CaseTypeSelectSlice = createSlice({
  name: "CaseTypeSelect",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCaseTypeSelectModels.pending, (state) => {
        state.Loading = true;
      })
      .addCase(getCaseTypeSelectModels.rejected, (state) => {
        state.CaseTypeSelectModels = new Array<IntSelectModel>();
        state.Loading = false;
        state.LastUpdateTime = new Date();
      })
      .addCase(getCaseTypeSelectModels.fulfilled, (state, action) => {
        state.CaseTypeSelectModels = action.payload;
        state.Loading = false;
        state.LastUpdateTime = new Date();
      });
  },
});

export const getCaseTypeSelectModels = createAsyncThunk("CaseTypeSelect/GetSelectModels", async () => {
  const caseTypesService = container.get<IClientPortalCaseTypesService>(SERVICE_TYPES.ClientPortalCaseTypesService);
  return await caseTypesService.getCaseTypeSelectModels();
});

export const selectCaseTypeSelectModels = (state: RootState) => state.caseTypeSelect.CaseTypeSelectModels;
export const selectLoadingCaseTypeSelectModels = (state: RootState) => state.caseTypeSelect.Loading;
export const selectLastUpdateTime = (state: RootState) => state.caseTypeSelect.LastUpdateTime;

export default CaseTypeSelectSlice.reducer;
